import * as React from 'react';

import { UitkSheet } from 'uitk-react-sheet';

import { HoldingAreaHeader } from 'components/multi-item/holding-area-header';

export interface ItemsPlaybackProps {
  itemCount?: number;
  linkTo: {
    pathname: string;
    search: string;
  };
  setToggleRef: (ref) => void;
  titleText: string;
}

export const ItemsPlayback = ({ itemCount, linkTo, setToggleRef, titleText }: ItemsPlaybackProps) => (
  <UitkSheet className="uitk-grid uitk-type-400 all-x-padding-three all-y-padding-three" isVisible={itemCount > 0} autoFocus={false}>
    <HoldingAreaHeader setToggleRef={setToggleRef} linkTo={linkTo} numberOfItems={itemCount} titleText={titleText} />
  </UitkSheet>
);
